import React, { useEffect } from 'react';
import { FiX, FiExternalLink } from 'react-icons/fi';
import { useLightbox } from '../../context/LightboxContext';
import './ImageLightboxModal.css';

const ImageLightboxModal = () => {
    const { isOpen, activeImage, closeLightbox } = useLightbox();

    useEffect(() => {
        if (!isOpen) return undefined;

        const handleKeyDown = (e) => {
            if (e.key === 'Escape') closeLightbox();
        };

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', handleKeyDown);

        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, closeLightbox]);

    if (!isOpen || !activeImage) return null;

    const rawTitle = (activeImage.title || activeImage.alt || '').trim();
    const title = rawTitle || 'Rahber Corporation | Genuine Appliance';
    const subtitle = (activeImage.subtitle || activeImage.caption || '').trim() ||
        '100% Genuine Box-Packed with Official Manufacturer Warranty • Lahore Showroom';

    return (
        <div
            className="lightbox-overlay"
            onClick={closeLightbox}
            role="dialog"
            aria-modal="true"
            aria-label="Enlarged Image Viewer"
        >
            <div className="lightbox-wrapper" onClick={(e) => e.stopPropagation()}>
                {/* Top Header Bar */}
                <div className="lightbox-topbar">
                    <div className="lightbox-meta">
                        <h3 className="lightbox-title-text">{title}</h3>
                        {subtitle && <p className="lightbox-sub-text">{subtitle}</p>}
                    </div>

                    <div className="lightbox-actions">
                        <a
                            href={activeImage.src}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="lightbox-action-btn"
                            title="Open HD Original"
                        >
                            <FiExternalLink />
                            <span>HD View</span>
                        </a>

                        <button
                            type="button"
                            className="lightbox-close-orange-btn"
                            onClick={closeLightbox}
                            aria-label="Close image viewer"
                            title="Close (Esc)"
                        >
                            <FiX />
                        </button>
                    </div>
                </div>

                {/* Center Image Container */}
                <div className="lightbox-media-container" onClick={closeLightbox}>
                    <img
                        src={activeImage.src}
                        alt={title}
                        className="lightbox-hero-img"
                        onClick={(e) => {
                            e.stopPropagation();
                            window.open(activeImage.src, '_blank');
                        }}
                        title="Click image to open in new tab"
                    />
                </div>

                {/* Bottom Hint */}
                <div className="lightbox-footer-hint">
                    Press Esc or click anywhere outside to close
                </div>
            </div>
        </div>
    );
};

export default ImageLightboxModal;
